import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/site';

export default function FaqSection({ showMore = true }: { showMore?: boolean }) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-background-50" aria-labelledby="faq-title">
      <div className="container-page py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <p className="text-xs tracking-[0.3em] text-primary-600 font-medium">常见问题</p>
            <h2 id="faq-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              关于看料爆料，你可能想问
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              还有别的问题？可以在关于我们页面提交，我们会把高频问题补充到这里。
            </p>
            {showMore && (
              <Link
                to="/about"
                className="mt-5 inline-flex items-center gap-2 rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                更多说明
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            )}
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 rounded-xl border border-background-200 bg-background-100">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div key={faq.q} className="px-5 md:px-6">
                    <h3>
                      <button
                        type="button"
                        onClick={() => setOpenIndex(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="flex w-full items-center justify-between gap-4 py-5 text-left cursor-pointer"
                      >
                        <span className="font-heading text-base font-semibold text-foreground-950">{faq.q}</span>
                        <span className="w-6 h-6 flex items-center justify-center shrink-0 text-primary-600">
                          <i className={isOpen ? 'ri-subtract-line text-xl' : 'ri-add-line text-xl'}></i>
                        </span>
                      </button>
                    </h3>
                    {isOpen && (
                      <p className="pb-5 -mt-1 text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}